/**
 * Returns the percentage value.
 *
 * @param {Number} partialValue
 * @param {Number} totalValue
 * @returns {Number}
 */
export const percentage = (partialValue, totalValue) => {
  if (totalValue === 0) {
    return 0;
  }

  return (100 * partialValue) / totalValue;
};

/**
 * Checks if the given variable is a number.
 *
 * @param {Number} value
 * @returns {Boolean}
 */
export const isNumber = (value) => {
  return typeof value === "number" && isFinite(value);
};
